import { useNavigate } from 'react-router-dom'

import success from '@/assets/lotties/success.json'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'

export const PaymentSuccess = () => {
  const navigate = useNavigate()

  const handleStartSelfCheck = () => {
    navigate(AppRoutes.confirmSearchInfo)
  }

  const handleOpenDashboard = () => {
    navigate(AppRoutes.dashboard)
  }

  return (
    <WeScreen useHeader={false}>
      <Feedback
        lottie={success}
        lottieLoop={false}
        title="All set!"
        message="Social Mirror unlocked. See what shows up in minutes."
        primaryButtontext="Start Social Mirror"
        onClickPrimaryButton={handleStartSelfCheck}
        secondaryButtontext="Open dashboard"
        onClickSecondaryButton={handleOpenDashboard}
      />
    </WeScreen>
  )
}
